import { useState, type JSX } from 'react';
import { z } from 'zod';
import type { BotScope } from '@cryptology-assist/domain';
import { request, botPath, savedSchema, type Session } from './api';
import { useRemote } from './hooks';
import { ErrorNotice, Field, onSubmit, useMutation } from './components';
import type { Copy } from './copy';
const originsSchema = z.object({
  knowledge: z.array(z.string()),
  business: z.array(z.string()),
});
export function SourceOrigins({
  scope,
  purpose,
  session,
  copy,
}: {
  scope: BotScope;
  purpose: 'knowledge' | 'business';
  session: Session;
  copy: Copy;
}): JSX.Element | null {
  const origins = useRemote(botPath(scope, 'source-origins'), originsSchema);
  const [origin, setOrigin] = useState('');
  const mutation = useMutation();
  if (!session.canCreateInstallation) return null;
  return (
    <details className="form-section">
      <summary>{copy.approvedSourceOrigins}</summary>
      <p>{copy.approvedSourceOriginsHelp}</p>
      <ul>
        {origins.data?.[purpose].map((value) => (
          <li key={value}>
            {value}{' '}
            <button
              disabled={mutation.busy}
              onClick={() =>
                void mutation.run(async () => {
                  await request(botPath(scope, 'source-origins'), savedSchema, {
                    csrf: session.csrf,
                    method: 'DELETE',
                    body: { purpose, origin: value },
                  });
                  origins.reload();
                })
              }
            >
              {copy.salesRemove}
            </button>
          </li>
        ))}
      </ul>
      <form
        onSubmit={(event) =>
          onSubmit(event, () =>
            mutation.run(async () => {
              await request(botPath(scope, 'source-origins'), savedSchema, {
                csrf: session.csrf,
                body: { purpose, origin },
              });
              setOrigin('');
              origins.reload();
            })
          )
        }
      >
        <Field label={copy.sourceOrigin}>
          <input
            required
            type="url"
            value={origin}
            onChange={(event) => setOrigin(event.target.value)}
          />
        </Field>
        <button disabled={mutation.busy}>{copy.approveSourceOrigin}</button>
      </form>
      <ErrorNotice error={origins.error ?? mutation.error} copy={copy} />
    </details>
  );
}
